// @flow
import { Map, fromJS } from "immutable";
import {userRoleSelector} from "../../../security";
import {ADMIN_ROLE} from "../../../constants";

export const btuMetersSelector = (state: Map<string, any>) =>
  state.getIn(["meter", "btuMeters"]);

export const btuMetersGroupsSelector = (state: Map<string, any>) => {
  const groups = [];
  const btuMeters = btuMetersSelector(state)
  btuMeters.forEach(meter => {
    if(!groups.includes(meter.get("group"))) {
      groups.push(meter.get("group"))
    }
  });
  return fromJS(groups)
}

export const metersSelector = (state: Map<string, any>) =>
  state.getIn(["meter", "meters"]);

export const meterGroupsSelector = (state: Map<string, any>) => {
  const groups = [];
  const userRole = userRoleSelector(state)
  const meters = userRole === ADMIN_ROLE ? metersSelector(state) : btuMetersSelector(state)
  meters.forEach(meter => {
    if(!groups.includes(meter.get("group"))) {
      groups.push(meter.get("group"))
    }
  });
  return fromJS(groups)
}

export const electricalMetersSelector = (state: Map<string, any>) =>
  state.getIn(["meter", "electricalMeters"]);

export const electricalMeterGroupsSelector = (state: Map<string, any>) => {
  const groups = [];
  const electricalMeters = electricalMetersSelector(state)
  electricalMeters.forEach(meter => {
    if(!groups.includes(meter.get("group"))) {
      groups.push(meter.get("group"))
    }
  });
  return fromJS(groups)
}

export const btuMeterAddressesSelector = (state: Map<string, any>) =>
  state.getIn(["meter", "btuMeters"])
    .filter(m => {
      const locationId = state.getIn(["account", "accountInfo", "locationId"]);
      return m.get("locationId") === locationId;
    })
    .map(m => m.get("addressId"))
    .toSet()
    .toList();

export const meterAddressesSelector = (state: Map<string, any>) =>
  state.getIn(["meter", "meters"])
    .filter(m => {
      const locationId = state.getIn(["account", "accountInfo", "locationId"]);
      return m.get("locationId") === locationId;
    })
    .map(m => m.get("addressId"))
    .toSet()
    .toList();

export const meterErrorSelector = state => state.getIn(["meter", "error"]);



// WEBPACK FOOTER //
// ./src/features/meter/store/meterSelectors.js